import * as Yup from "yup";
import REGEXS from "../utils/regex";
import { isDateNotFuture } from "../helpers/commonHelper";
import { validateUploadedFile, formatValidationErrors } from "../helpers/fileValidationHelper";

export const diagnosticDetailsSchema = Yup.object().shape({

  date_of_diagnosis: Yup.string()
    .nullable()
    .transform((value, originalValue) => {
      return originalValue === "null" ? null : value;
    })
    .test(
      "not-future-date",
      "Date of diagnosis cannot be in the future",
      function (value) {
        if (!value) return true; // skip validation if empty/null
        return isDateNotFuture(value);
      }
    ),

  // Alphanumeric validations
  primary_tumour_site: Yup.string()
    .test(
      'is-alphanumeric',
      'Primary site must contain only letters, numbers and spaces',
      function (value) {
        if (!value) return true;
        return REGEXS.alplabhetNumeric.test(value);
      }
    ),

  histology_morphology_description: Yup.string()
    .test(
      'is-alphanumeric',
      'Histology/Morphology must contain only letters, numbers and spaces',
      function (value) {
        if (!value) return true;
        return REGEXS.alplabhetNumeric.test(value);
      }
    ),

  secondary_tumour_site: Yup.string()
    .test(
      'is-alphanumeric',
      'Secondary site must contain only letters, numbers and spaces',
      function (value) {
        if (!value) return true;
        return REGEXS.alplabhetNumeric.test(value);
      }
    ),

  metastasis_morphology: Yup.string()
    .test(
      'is-alphanumeric',
      'Morphology must contain only letters, numbers and spaces',
      function (value) {
        if (!value) return true;
        return REGEXS.alplabhetNumeric.test(value);
      }
    ),

  // Document array validation
  documents: Yup.array().of(
    Yup.object().shape({
      document_name: Yup.string()
        .test(
          'required-with-file',
          'Document name is required when file is uploaded',
          function (value) {
            const { documents } = this.parent;
            // Only require name if NEW file is uploaded
            if (documents && documents.name) {
              return !!value && value.trim().length > 0;
            }
            return true;
          }
        ),

      documents: Yup.mixed()
        .nullable() // ← CRITICAL: Allow null values
        .test(
          'required-with-name',
          'Document file is required when document name is entered',
          function (value) {
            const { document_name, existingFilePath, documentId } = this.parent;

            // If there's an existing file (path or id), pass validation
            if (existingFilePath || documentId) {
              return true;
            }

            // If document_name exists but no existing file, require new upload
            if (document_name && document_name.trim().length > 0) {
              return !!value && value.name;
            }

            // No document_name and no file = OK (empty row)
            return true;
          }
        )
        .test(
          'secure-file-validation',
          'File validation failed',
          async function (value) {
            // Skip validation if no file
            if (!value || !value.name) return true;

            // Perform comprehensive security validation
            const validation = await validateUploadedFile(value);

            if (!validation.isValid) {
              // Return the first error message
              return this.createError({
                message: formatValidationErrors(validation.errors)
              });
            }

            return true;
          }
        ),

      remarks: Yup.string(),

      // Explicitly declare these fields so Yup includes them
      existingFilePath: Yup.string().nullable().optional(),
      documentId: Yup.number().nullable().optional(),
    })
  ),
});